import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mercedsrenlswithdriverindelhi() {



  const cardData =
  {
    keyword: 'Mercedes Rentals with Drivers in Delhi',
    heading: 'Aaryan Travels: Mercedes Rentals with Drivers in Delhi',
    headingDescription: 'Aaryan Travels offers premium Mercedes Rentals with Drivers in Delhi for executives, VIP guests, weddings, and special occasions requiring luxury and elegance. Whether it’s airport pickups from IGI Airport, corporate meetings in Aerocity, hotel transfers, or wedding entry rides, our chauffeur-driven Mercedes sedans ensure a first-class travel experience. With well-dressed professional drivers, plush interiors, and on-request amenities like bottled water and Wi-Fi, we deliver unmatched comfort and prestige on every journey. From South Delhi to Gurgaon and Noida, Aaryan Travels is the trusted choice for Mercedes car rentals with drivers in Delhi for both business and ceremonial travel.',

    top: 'Top Places to Visit in Delhi with Aaryan Travels',

"topPlaces": [
  {
    "title": "Red Fort (Lal Qila)",
    "description": "Red Fort, built in 1648 by Emperor Shah Jahan, is a UNESCO World Heritage Site known for its grand red sandstone walls and Mughal architecture. It once served as the royal residence of Mughal emperors. The evening sound-and-light show narrates its glorious past. Every Independence Day, the national flag is hoisted here. Red Fort is Delhi’s enduring symbol of power and freedom."
  },
  {
    "title": "India Gate",
    "description": "India Gate is a 42-meter war memorial dedicated to Indian soldiers who sacrificed their lives in World War I. The eternal flame, Amar Jawan Jyoti, honors their bravery. Surrounded by lush lawns, it is a popular spot for picnics and evening walks. Lit up beautifully at night, it creates a stunning view. India Gate is Delhi’s patriotic beacon of remembrance."
  },
  {
    "title": "Qutub Minar",
    "description": "Qutub Minar is the world’s tallest brick minaret, standing at 73 meters. Built in the 12th century, it features intricate carvings and Quranic inscriptions. The surrounding complex includes historic mosques and the famous Iron Pillar. Visitors admire its architectural splendor and historical significance. Qutub Minar is Delhi’s towering masterpiece of heritage."
  },
  {
    "title": "Lotus Temple",
    "description": "The Lotus Temple is a Bahá’í House of Worship shaped like a blooming lotus with 27 marble petals. Open to people of all faiths, it offers a peaceful space for meditation. Surrounded by water pools and gardens, it exudes calmness. Silence is the only ritual observed here. Lotus Temple is Delhi’s serene symbol of unity and spirituality."
  },
  {
    "title": "Humayun’s Tomb",
    "description": "Humayun’s Tomb, built in 1570, is a stunning Mughal mausoleum that inspired the design of the Taj Mahal. Surrounded by Persian-style gardens and water channels, it radiates symmetry and elegance. The peaceful environment makes it ideal for walks and photography. Humayun’s Tomb is Delhi’s graceful testament to Mughal legacy."
  },
  {
    "title": "Akshardham Temple",
    "description": "Akshardham Temple is a massive spiritual and cultural complex known for its detailed carvings and grand architecture. Built without steel, it features over 20,000 statues of deities and saints. The musical fountain show and cultural boat ride attract visitors of all ages. Akshardham is Delhi’s dazzling tribute to devotion and craftsmanship."
  },
  {
    "title": "Jama Masjid",
    "description": "Jama Masjid is one of India’s largest mosques, built in 1656 by Shah Jahan. Its courtyard can accommodate over 25,000 worshippers. The red sandstone and marble structure features domes and minarets offering city views. Nearby food lanes serve kebabs, biryanis, and sweets. Jama Masjid is Delhi’s vibrant blend of spirituality and flavor."
  },
  {
    "title": "Raj Ghat",
    "description": "Raj Ghat is a black marble memorial marking the cremation site of Mahatma Gandhi. Surrounded by serene gardens and eternal flames, it offers a peaceful space for reflection. World leaders often visit to pay homage. Inspirational quotes by Gandhi adorn the pathways. Raj Ghat is Delhi’s humble tribute to the Father of the Nation."
  },
  {
    "title": "Hauz Khas Village",
    "description": "Hauz Khas Village combines medieval ruins with modern cafes, art boutiques, and nightlife spots. The 14th-century Hauz Khas Fort overlooks a scenic lake, offering picturesque sunset views. It’s popular among artists, travelers, and partygoers. Hauz Khas is Delhi’s stylish fusion of history and leisure."
  },
  {
    "title": "Chandni Chowk & Paranthe Wali Gali",
    "description": "Chandni Chowk is one of Delhi’s oldest markets known for spices, jewelry, and fabrics. Paranthe Wali Gali is famous for its stuffed parathas served with pickles and chutneys. Rickshaws, street stalls, and temple bells create a nostalgic ambiance. Chandni Chowk is Delhi’s bustling heart of flavors and tradition."
  }
],


"services": [
  {
    "name": "Mercedes Rentals with Drivers in Delhi",
    "description": "Mercedes Rentals with Drivers in Delhi offer a premium travel experience combining luxury, comfort, and professionalism. Our fleet of meticulously maintained Mercedes vehicles is driven by experienced chauffeurs who prioritize punctuality, safety, and personalized service. Whether for corporate travel, special events, or airport transfers, we ensure a smooth, elegant journey tailored to your specific needs. Our service emphasizes discretion and attention to detail, making every ride a first-class experience."
  },
  {
    "name": "Mercedes Hire with Driver Delhi",
    "description": "Mercedes Hire with Driver Delhi provides hassle-free luxury car rentals with professional drivers to meet all your transportation needs. Ideal for business executives, VIPs, and discerning travelers, this service guarantees timely pickups, comfortable rides, and impeccable service standards. Our chauffeurs are trained to offer courteous and efficient assistance, helping you focus on your priorities while we handle the logistics of your journey."
  },
  {
    "name": "Chauffeur Driven Mercedes Delhi",
    "description": "Chauffeur Driven Mercedes Delhi delivers a sophisticated transportation option for those who demand the best in comfort and style. Each ride is managed by professional drivers well-versed in city routes and corporate etiquette, ensuring seamless navigation and a relaxing environment. Perfect for business trips, weddings, and luxury travel, this service blends the prestige of Mercedes vehicles with exceptional chauffeur service."
  },
  {
    "name": "Executive Mercedes Rental Delhi",
    "description": "Executive Mercedes Rental Delhi is tailored for high-level corporate travelers seeking a combination of luxury and efficiency. Our premium Mercedes sedans and SUVs come equipped with state-of-the-art amenities and are driven by chauffeurs trained in executive-level customer care. Whether attending meetings, conferences, or client visits, you can count on our service to provide a refined and punctual transportation experience."
  },
  {
    "name": "Premium Mercedes Cab Delhi",
    "description": "Premium Mercedes Cab Delhi offers top-of-the-line Mercedes vehicles paired with attentive and skilled drivers to elevate your travel experience. We cater to individuals and corporate clients who value comfort, luxury, and professionalism. Our service includes real-time vehicle tracking, flexible booking options, and a commitment to exceeding client expectations with every ride."
  },
  {
    "name": "Mercedes SUV Rental Delhi",
    "description": "Mercedes SUV Rental Delhi provides spacious, luxurious SUVs ideal for group travel, family outings, or clients with extra luggage. Our vehicles come with advanced safety features and plush interiors, while our chauffeurs ensure a smooth, secure journey. This service is perfect for business groups, airport transfers, and special events requiring both comfort and style."
  },
  {
    "name": "Luxury Mercedes Service Delhi",
    "description": "Luxury Mercedes Service Delhi focuses on delivering an unparalleled travel experience featuring the latest Mercedes models equipped with premium interiors and modern amenities. Our professional chauffeurs maintain the highest standards of customer service, ensuring your trip is comfortable, safe, and tailored to your preferences. From corporate needs to celebratory occasions, we provide a distinguished transportation service."
  },
  {
    "name": "Corporate Mercedes Rental Delhi",
    "description": "Corporate Mercedes Rental Delhi specializes in providing customized rental solutions for businesses requiring reliable, high-end transportation. We offer monthly contracts, priority booking, and dedicated account management to streamline your corporate travel. Our chauffeur-driven Mercedes fleet ensures your executives and clients arrive in style and on time, reinforcing your company’s professional image."
  },
  {
    "name": "Mercedes Sedan Hire Delhi",
    "description": "Mercedes Sedan Hire Delhi features sleek and elegant Mercedes sedans perfect for individual executives or small groups. Equipped with plush seating and advanced climate control, these sedans provide a refined and relaxing environment. Our chauffeurs deliver attentive service, ensuring every journey is smooth and hassle-free."
  },
  {
    "name": "Best Mercedes Driver Cab Delhi",
    "description": "Best Mercedes Driver Cab Delhi is known for exceptional service quality, combining a premium fleet with expert drivers dedicated to client satisfaction. We offer 24x7 availability, flexible booking, and competitive pricing without compromising on luxury or reliability. Choose us for a consistently outstanding Mercedes cab experience."
  },
  {
    "name": "Affordable Mercedes Cab Delhi",
    "description": "Affordable Mercedes Cab Delhi makes luxury accessible by providing competitively priced Mercedes rentals with professional drivers. Our transparent pricing, clean vehicles, and commitment to customer service ensure you enjoy the prestige of a Mercedes without stretching your budget, ideal for both occasional and regular travelers."
  },
  {
    "name": "Mercedes Chauffeur Service Delhi",
    "description": "Mercedes Chauffeur Service Delhi offers expertly trained chauffeurs who provide discreet, courteous, and efficient driving. This service caters to executives, VIPs, and individuals seeking luxury transportation with attention to detail. We handle your routes and schedules so you can focus on what matters most."
  },
  {
    "name": "Mercedes Rental Packages Delhi",
    "description": "Mercedes Rental Packages Delhi provides flexible rental options tailored to different durations and travel requirements. Whether you need a daily rental, weekly service, or monthly package, we offer competitive rates and customizable plans designed to meet the demands of corporate and private clients."
  },
  {
    "name": "Online Mercedes Booking Delhi",
    "description": "Online Mercedes Booking Delhi simplifies the process of reserving luxury Mercedes vehicles with drivers through an easy-to-use digital platform. Enjoy instant confirmations, transparent pricing, and real-time tracking, all accessible from your smartphone or computer for hassle-free luxury transportation."
  },
  {
    "name": "Mercedes Car Hire Delhi",
    "description": "Mercedes Car Hire Delhi provides premium vehicles for rent with or without chauffeurs, catering to a variety of client needs from business travel to personal luxury rides. Our fleet is maintained to the highest standards to ensure comfort, safety, and style throughout your journey."
  }
],
"tableData": [
  ["Mercedes Rentals with Drivers in Delhi", "Mercedes Hire with Driver Delhi"],
  ["Chauffeur Driven Mercedes Delhi", "Executive Mercedes Rental Delhi"],
  ["Premium Mercedes Cab Delhi", "Mercedes SUV Rental Delhi"],
  ["Luxury Mercedes Service Delhi", "Corporate Mercedes Rental Delhi"],
  ["Mercedes Sedan Hire Delhi", "Best Mercedes Driver Cab Delhi"],
  ["Affordable Mercedes Cab Delhi", "Mercedes Chauffeur Service Delhi"],
  ["Mercedes Rental Packages Delhi", "Online Mercedes Booking Delhi"],
  ["Mercedes Car Hire Delhi", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Mercedes Rentals with Drivers in Delhi",
    "WhyChoosedescription": "Aaryan Travels offers luxurious Mercedes rentals with professional drivers in Delhi for a premium travel experience."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Chauffeurs",
    "WhyChoosedescription": "Our well-trained drivers ensure a smooth, safe, and punctual ride with top-tier professionalism."
  },
  {
    "WhyChooseheading": "Well-Maintained Luxury Mercedes Vehicles",
    "WhyChoosedescription": "Ride in sanitized, air-conditioned Mercedes cars that are regularly serviced for comfort and safety."
  },
  {
    "WhyChooseheading": "Expert Drivers with Knowledge of Delhi Routes",
    "WhyChoosedescription": "Our chauffeurs are familiar with Delhi’s roads and traffic patterns, ensuring efficient travel."
  },
  {
    "WhyChooseheading": "Transparent and All-Inclusive Pricing",
    "WhyChoosedescription": "Enjoy clear, upfront pricing with no hidden charges—fuel, tolls, and driver fees are included."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Service",
    "WhyChoosedescription": "Our support team is available at all times to assist you with bookings and travel-related queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, daily, or full-day Mercedes rental plans to match your schedule and needs."
  },
  {
    "WhyChooseheading": "Ideal for Business, Events, or Leisure",
    "WhyChoosedescription": "Our Mercedes rentals are perfect for corporate travel, VIP transfers, weddings, or luxurious city rides."
  }
]
























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer Mercedes rentals with drivers in Delhi?',
    answer: 'Yes, Aaryan Travels provides premium Mercedes rentals with professional drivers in Delhi for luxury travel experiences.',
  },
  {
    question: 'How can I book a Mercedes with a driver in Delhi through Aaryan Travels?',
    answer: 'You can book easily via our website, mobile app, or by contacting our 24x7 luxury cab support team.',
  },
  {
    question: 'Which Mercedes models are available for rental with drivers in Delhi?',
    answer: 'We offer a selection of premium Mercedes models including C-Class, E-Class, and S-Class based on your requirements.',
  },
  {
    question: 'Are the drivers professionally trained for luxury cab services in Delhi?',
    answer: 'Yes, all our drivers are professionally trained, uniformed, and experienced in providing luxury-level service.',
  },
  {
    question: 'Can I book a chauffeur-driven Mercedes for airport transfers, business meetings, or special events in Delhi?',
    answer: 'Absolutely. Aaryan Travels caters to all types of occasions, including airport transfers, corporate travel, and VIP events.',
  },
  {
    question: 'Is the Mercedes rental with driver service available 24x7 in Delhi?',
    answer: 'Yes, Aaryan Travels offers 24x7 Mercedes rentals with drivers to suit your schedule and convenience.',
  },
  {
    question: 'Are hygiene and safety standards maintained in Mercedes rentals?',
    answer: 'Yes, all Mercedes vehicles are sanitized before each trip and our chauffeurs follow strict hygiene and safety protocols.',
  },
  {
    question: 'What payment methods are accepted for Mercedes rentals with drivers in Delhi?',
    answer: 'We accept cash, credit/debit cards, UPI, digital wallets, and corporate account payments.',
  },
  {
    question: 'Is customer support available during my Mercedes rental ride in Delhi?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aman Khurana',
    feedback: 'Rented a Mercedes E-Class with Aaryan Travels in Delhi — top-notch service, professional driver, and a very smooth experience.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Radhika Malhotra',
    feedback: 'Perfect luxury experience! The Mercedes was immaculate and the chauffeur was extremely courteous. Highly recommend Aaryan Travels.',
    rating: 5,
  },
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const mercedesRentalsSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mercedes Rentals with Drivers in Delhi",
  "description": "Aaryan Travels offers chauffeur driven Mercedes rentals in Delhi, including luxury sedans and SUVs with professional drivers for executive and corporate travel.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Delhi"
  },
  "serviceType": "Chauffeur Driven Mercedes Rental Service",
  "keywords": "Mercedes Rentals with Drivers in Delhi, Mercedes Hire with Driver Delhi, Chauffeur Driven Mercedes Delhi, Executive Mercedes Rental Delhi, Premium Mercedes Cab Delhi, Mercedes SUV Rental Delhi, Luxury Mercedes Service Delhi, Corporate Mercedes Rental Delhi, Mercedes Sedan Hire Delhi, Best Mercedes Driver Cab Delhi, Affordable Mercedes Cab Delhi, Mercedes Chauffeur Service Delhi, Mercedes Rental Packages Delhi, Online Mercedes Booking Delhi, Mercedes Car Hire Delhi"
};







  return (
    <div>

<Helmet>
  <title>Mercedes Rentals with Drivers in Delhi | Luxury Mercedes Hire | Aaryan Travels</title>
  <meta
    name="description"
    content="Book chauffeur driven Mercedes rentals in Delhi with Aaryan Travels. Luxury Mercedes sedans and SUVs with professional drivers for executive and corporate use."
  />
  <meta
    name="keywords"
    content="Mercedes Rentals with Drivers in Delhi, Mercedes Hire with Driver Delhi, Chauffeur Driven Mercedes Delhi, Executive Mercedes Rental Delhi, Premium Mercedes Cab Delhi, Mercedes SUV Rental Delhi, Luxury Mercedes Service Delhi, Corporate Mercedes Rental Delhi, Mercedes Sedan Hire Delhi, Best Mercedes Driver Cab Delhi, Affordable Mercedes Cab Delhi, Mercedes Chauffeur Service Delhi, Mercedes Rental Packages Delhi, Online Mercedes Booking Delhi, Mercedes Car Hire Delhi"
  />
  <script type="application/ld+json">
    {JSON.stringify(mercedesRentalsSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/61.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mercedsrenlswithdriverindelhi;